import Loadable from '../../components/loadable';

const ArchivedMembershipPlansList = Loadable({
  loader: () => import('../../pages/membership_plans/archived_membership_plans_list/archived_membership_plan_list'),
  type: 'block',
});

angular.module('gym').value('ArchivedMembershipPlansList', ArchivedMembershipPlansList);

const UnarchiveMembershipPlanModal = Loadable({
  loader: () => import('../../pages/membership_plans/archived_membership_plans_list/unarchive_membership_plan_modal'),
  type: 'modal',
});

angular.module('gym').value('UnarchiveMembershipPlanModal', UnarchiveMembershipPlanModal);

const MembershipPlanDetailsModal = Loadable({
  loader: () => import('../../pages/membership_plans/archived_membership_plans_list/membership_plan_details_modal'),
  type: 'modal',
});

angular.module('gym').value('MembershipPlanDetailsModal', MembershipPlanDetailsModal);
